import { render, staticRenderFns } from "./Gallery4.vue?vue&type=template&id=52fac6b3&scoped=true&"
import script from "./Gallery4.vue?vue&type=script&lang=js&"
export * from "./Gallery4.vue?vue&type=script&lang=js&"
import style0 from "./Gallery4.vue?vue&type=style&index=0&id=52fac6b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fac6b3",
  null
  
)

export default component.exports